import React from 'react';
import { useTranslation } from 'react-i18next';
import { AccessLevel } from 'lavva.exalushome/build/js/Services/Users/IUser';
import { IconWarning } from '../../../../assets/icons/icon-warning';
import { EmptyStateBox, Page, Tabs } from '../../../../components';
import { MainHeader } from '../../../../components/main-header';
import { useInstallationContext } from '../../../../context/installation';
import { useExalusContext } from '../../context';
import { useExalusStorageContext } from '../../context/storage';
import { useExalusChannelStateGroupChanged } from '../../hooks/channels';
import { useLoggedUser } from '../../hooks/common/logged-user';
import { DialogsExalus } from '../dialogs/dialogs';
import { ExalusGroups } from './components/groups';
import { useGroups } from './hooks/use-groups';

const Groups: React.FC = () => {
  const { t } = useTranslation('dashboard');
  const { selectedInstallation, installationList } = useInstallationContext();
  const { allGroups } = useExalusContext();
  const { popUpNavLinks, tabs } = useGroups();
  const { user } = useLoggedUser();
  const { setActiveGroup, activeGroupIndex } = useExalusStorageContext();
  useExalusChannelStateGroupChanged();

  return (
    <Page
      isStickyHeader
      containerClassName="page__container--flex-height"
      carouselContent={installationList.length !== 0 || selectedInstallation !== undefined}
      className="dashboard"
      header={
        <>
          <MainHeader navLinks={popUpNavLinks} />
          {allGroups.length > 0 && (
            <Tabs
              tabList={tabs}
              activeTabIndex={activeGroupIndex}
              setActiveTabIndex={setActiveGroup}
              tabsType="pills"
              isDivider={false}
              moreButton="secondary"
            />
          )}
        </>
      }
    >
      {user ? (
        <>
          {user.AccessLevel !== AccessLevel.Guest ? (
            <>
              <ExalusGroups />
              <DialogsExalus />
            </>
          ) : (
            <EmptyStateBox
              header={t('exalus.groupsPermissions.header')}
              content={t('exalus.groupsPermissions.content')}
              icon={<IconWarning />}
            />
          )}
        </>
      ) : null}
    </Page>
  );
};

export default Groups;
